/**
 * PopupSectionHeader Component
 *
 * Reusable header for Review Alert sidebar sections with BACK button navigation.
 * Used in: Review Alert, Review Feed, Filters, Visibility, Sources sections.
 *
 * @param {string} title - Section title to display
 * @param {function} onBack - Callback function when BACK button is clicked
 */
import { __ } from '@wordpress/i18n';
import SbUtils from '../../Utils/SbUtils';

const PopupSectionHeader = ( { title, onBack } ) => (
	<div className="sb-popup-section-header sb-fs">
		<button
			className="sb-popup-back-btn"
			onClick={ onBack }
		>
			{ SbUtils.printIcon( 'chevron-left' ) }
			<span>{ __( 'BACK', 'reviews-feed' ) }</span>
		</button>
		<h2 className="sb-popup-section-title">{ title }</h2>
	</div>
);

export default PopupSectionHeader;
